import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { COLOR, FONT } from '../../../constants/styles';
import OPComponent from '../op_component';
import TextUtils from '../../../textUtils';

export default class PlaceholderText extends OPComponent {
  render() {
    const { label, required, editable = true, containerStyle } = this.props;

    return (
      <Text
        style={[styles.placeholderText, !editable ? styles.disabled : null, containerStyle]}
        pointerEvents="none"
      >
        {TextUtils.ac(label)}
        <Text style={styles.asteriskSpace}> </Text>
        <Text style={styles.requiredAsterisk}>{required ? '*' : ''}</Text>
      </Text>
    );
  }
}

const styles = StyleSheet.create({
  placeholderText: {
    ...FONT.regular,
    color: COLOR.textLight,
    fontSize: 18,
  },
  asteriskSpace: {
    fontSize: 6,
  },
  requiredAsterisk: {
    color: COLOR.emphasis,
    paddingLeft: 2,
    fontSize: 18,
    // backgroundColor: 'pink'
  },
  disabled: {
    color: COLOR.textLight,
  },
});
